import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * The driver's call at a stop that neither picked up nor dropped a trailer.
 */
export const stopCallV1 = tmsEventKind(
  { category: "call", kind: "stopCall", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      stopName: z.string(),
      city: z.string().nullable(),
    },
  },
);

export const StopCallV1Schema = stopCallV1.schema;
export const StopCallV1FactsSchema = stopCallV1.facts;

export type StopCallV1 = z.infer<typeof StopCallV1Schema>;
export type StopCallV1Facts = z.infer<typeof StopCallV1FactsSchema>;

/** Every version of `stopCall`, keyed by version. What `catalog.ts` places under `call`. */
export const stopCall = { 1: stopCallV1 } as const;
